export const EmailRule = {
  required: true,
  message: "Please input valid email!"
};

export const EmailRuleRestirction = {
  required: true,
  type: "email",
  message: "Please input valid email!"
};

export const UserNameValidation = [
  {
    required: true,
    type: "regexp",
    message: "Please input your username"
  },
  {
    pattern: /^([a-zA-Z0-9]{3,30})$/,
    message: "Please input valid username!"
  }
];

export const UsernameOrEmailValidation = [
  {
    required: true,
    message: "Please input your username or email"
  }
];

export const PasswordRule = {
  required: true,
  message: "Please input your password!"
};

export const RequiredRule = {
  required: true,
  message: "This field is required"
};

export const RequiredFeildName = field => ({
  required: true,
  message: `${field} field is required`
});

export const TimeValidation = props => {
  const { getFieldValue } = props;
  return {
    validator({ field }, value) {
      if (!value || getFieldValue(field).toString().includes(":")) {
        return Promise.resolve();
      }
      return Promise.reject(new Error("Time value should be in this format: xx:xx"));
    }
  };
};

export const DutyTimeValidation = props => {
  const { getFieldValue } = props;
  return {
    validator({ field }, value) {
      if (!value || !getFieldValue(field).toString().includes(":")) {
        return Promise.resolve();
      }
      return Promise.reject(new Error("Format should be decimal eg 10.5"));
    }
  };
};

export const detailedPlaningMaxCharsRule = field => {
  let max = 0;
  if (field === "ref") {
    max = 50;
  } else if (field === "run") {
    max = 150;
  }
  return {
    max: max,
    message: `maximum ${max} characters.`
  };
};

export const detailedPlaningValidator = (rule, value) => {
  if (rule.field === "ref") {
    if (value && value.length > 50) {
      return Promise.reject(new Error("Maximum 50 characters."));
    }
    return Promise.resolve();
  }

  if (rule.field === "run") {
    if (value && value.length > 150) {
      return Promise.reject(new Error("Maximum 150 characters."));
    }
    return Promise.resolve();
  }

  if (rule.field === "time") {
    if (!value) {
      return Promise.reject(new Error("Time is required"));
    }
    // Accepts HH:mm or HHmm
    const regex = /^(\d{2}:\d{2}|\d{4})$/;
    if (!regex.test(value)) {
      return Promise.reject(new Error("Enter time as HH:mm or HHmm"));
    }
    return Promise.resolve();
  }
};

export const addBookingValidator = (rule, value) => {
  console.log(rule, value);
  if (rule.field === "RunDetails") {
    if (value && value.length > 150) {
      return Promise.reject(new Error("Maximum 150 characters."));
    }
    return Promise.resolve();
  }

  if (rule.field === "Time") {
    if (!value) {
      return Promise.reject(new Error("Time is required"));
    }
    // Accepts HH:mm or HHmm
    const regex = /^(\d{2}:\d{2}|\d{4})$/;
    if (!regex.test(value)) {
      return Promise.reject(new Error("Enter time as HH:mm or HHmm"));
    }
    return Promise.resolve();
  }
};

export const RequiredLimitRule = {
  min: 6,
  message: "Username must be minimum 5 characters."
};
